'use client'

import { Button, ButtonSize, ButtonVariant } from '@graftcode/design-system'

import type { ServiceMapCustomRange } from '../time-range.types'

import { CustomRangeSection } from './CustomRangeSection'
import type { CustomRangeSectionProps } from './CustomRangeSection/CustomRangeSection.types'

import styles from '../TimeRangeFilter.module.scss'

export type TimeRangeFilterCustomAndActionsProps = {
  showCustomSection: boolean
  pendingRange: ServiceMapCustomRange
  sectionLabels: CustomRangeSectionProps['labels']
  hour12: boolean
  dateFormat?: string
  onStartDateChange: CustomRangeSectionProps['onStartDateChange']
  onStartTimeChange: CustomRangeSectionProps['onStartTimeChange']
  onEndDateChange: CustomRangeSectionProps['onEndDateChange']
  onEndTimeChange: CustomRangeSectionProps['onEndTimeChange']
  cancelLabel: string
  applyLabel: string
  canApplyCustom: boolean
  onCancel: () => void
  onApply: () => void
}

export function TimeRangeFilterCustomAndActions({
  showCustomSection,
  pendingRange,
  sectionLabels,
  hour12,
  dateFormat,
  onStartDateChange,
  onStartTimeChange,
  onEndDateChange,
  onEndTimeChange,
  cancelLabel,
  applyLabel,
  canApplyCustom,
  onCancel,
  onApply,
}: TimeRangeFilterCustomAndActionsProps) {
  return (
    <>
      {showCustomSection ? (
        <div className={styles.customSectionWrapper}>
          <CustomRangeSection
            startDate={pendingRange.startDate}
            startTime={pendingRange.startTime}
            endDate={pendingRange.endDate}
            endTime={pendingRange.endTime}
            labels={sectionLabels}
            hour12={hour12}
            dateFormat={dateFormat}
            onStartDateChange={onStartDateChange}
            onStartTimeChange={onStartTimeChange}
            onEndDateChange={onEndDateChange}
            onEndTimeChange={onEndTimeChange}
          />
        </div>
      ) : null}
      <div className={styles.divider} aria-hidden="true" />
      <div className={styles.actions}>
        <Button text={cancelLabel} variant={ButtonVariant.Outlined} size={ButtonSize.M} onClick={onCancel} />
        <Button
          text={applyLabel}
          variant={ButtonVariant.Primary}
          size={ButtonSize.M}
          disabled={!canApplyCustom}
          onClick={onApply}
        />
      </div>
    </>
  )
}
